export const mapError = (err: number | boolean): string => {
  if (typeof err === 'number') {
    return 'Código invalido'
  }
  return 'Ocurrió un error'
}
